'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { hideAuthForm, showAuthForm } from '../../app/Auth/actions';

class AuthForm extends Component {
  constructor (props) {
    super(props);

    this.state = {
      typeForm: props.auth.get('formType'),
      formShow: props.auth.get('formShow', false) || false,
      resetComplete: false
    };

    this.hideAuthForm = props.hideAuthForm.bind(this);
    this.showAuthForm = props.showAuthForm.bind(this);
    this.handlerReset = this.handlerReset.bind(this);
    this.handlerClose = this.handlerClose.bind(this);
  }

  getHandlerShow (formType) {
    return (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.showAuthForm(formType);
    };
  }

  handlerReset (e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      resetComplete: true
    });
  }

  handlerClose (e) {
    e.preventDefault();
    e.stopPropagation();
    this.hideAuthForm();
    this.setState({
      resetComplete: false
    });
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if (!this.props.auth.equals(nextProps.auth)) {
      this.setState({
        typeForm: nextProps.auth.get('formType'),
        formShow: nextProps.auth.get('formShow')
      });
    }
  }

  render () {
    const formClass = classNames('modal-content animate-top', {
      signin: this.state.typeForm === 'signin',
      signup: this.state.typeForm === 'signup',
      restore: this.state.typeForm === 'restore'
    });

    const modalClass = classNames('modal full-screen', {
      'open fade in': this.state.formShow
    });

    return (
      <div className={modalClass}>
        <div className='modal-dialog full-screen'>
          <div className={formClass}>
            <div className='auth-form'>
              <button type='button' className='close' onClick={this.handlerClose}>×</button>

              <div className='reset-complete msg-complete' style={{display: this.state.resetComplete ? 'block' : 'none'}}>
                <div className='logo' />
                <hr />
                <p><strong>Мы отправили письмо</strong></p>
                <p>Вам на почту сейчас придёт письмо. Следуйте инструкциям указанным в нём.</p>
              </div>

              <div className='left-column back-form' style={{display: this.state.resetComplete ? 'none' : 'block'}}>
                <div className='logo' />
                <hr />
                <p><strong>Вы всё ещё <br /> не зарегистрировались?</strong></p>
                <p>Создайте своё объявление, общайтесь напрямую, выгодно покупайте и продавайте. Присоединяйтесь к нам.</p>
                <button className='switch-btn js-switch-btn' onClick={this.getHandlerShow('signup')}>Зарегистрироваться</button>
              </div>

              <div className='right-column back-form' style={{display: this.state.resetComplete ? 'none' : 'block'}}>
                <div className='logo' />
                <hr />
                <p><strong>Это займет пару минут!</strong></p>
                <p>Заполните эту простую форму и приступайте к работе.</p>
                <button className='switch-btn js-switch-btn login-slide-btn' onClick={this.getHandlerShow('signin')}>Войти</button>
              </div>

              <div className='form-container' style={{display: this.state.resetComplete ? 'none' : 'block'}}>
                <form className='signin-form'>
                  <div className='form-title'>Заходите</div>
                  <input type='text' className='form-control username' placeholder='E-mail' />
                  <p className='login-errorlist username-error'></p>

                  <input type='password' className='form-control password' placeholder='Пароль' />
                  <p className='login-errorlist pw-error'></p>

                  <button type='submit'>Войти</button>
                  <button className='switch-btn js-switch-btn' onClick={this.getHandlerShow('restore')}>Забыли пароль?</button>
                </form>

                <form className='signup-form'>
                  <div className='form-title'>Регистрация</div>
                  <input className='form-control fio' type='text' placeholder='Фамилия Имя Отчество' />
                  <p className='fioname-errorlist login-errorlist'></p>

                  <input className='form-control' type='email' placeholder='E-mail' />
                  <p className='email-errorlist login-errorlist'></p>

                  <input className='form-control' type='password' placeholder='Пароль' />
                  <p className='pw1-errorlist login-errorlist'></p>

                  <input className='form-control' type='password' placeholder='Подтверждение пароля' />
                  <p className='pw2-errorlist login-errorlist'></p>

                  <button type='submit' className='btn login-btn signup-submit'>Отправить</button>
                  <p className='conditions'>
                    Нажимая кнопку «Отправить», Вы принимаете условия <a target='blank' href='/page/default/offer/'>
                    договора (договора-оферты)</a> и подтверждаете, что ознакомились и принимаете
                    наши <a target='blank' rel='nofollow' href='/page/default/rules/'>"Правила пользования сайтом"</a>.
                  </p>
                </form>

                <form className='restore-form'>
                  <div className='form-title'>Восстановление пароля</div>
                  <button className='back-button js-switch-btn' onClick={this.getHandlerShow('signin')}>
                    <i className='icon-arrow-left' />
                  </button>

                  <p>Вам на почту придёт письмо с дальнейшими инструкциями по восстановлению пароля.</p>
                  <input type='email' className='form-control username reset' placeholder='E-mail' />
                  <p className='er-errorlist login-errorlist'></p>
                  <p className='info'></p>
                  <button type='submit' className='btn login-btn restore-submit' onClick={this.handlerReset}>Отправить</button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <TransitionGroup>
          {
            this.state.formShow &&
            <CSSTransition key={'modal-backdrop'} appear classNames='fade' timeout={300}>
              <div className='modal-backdrop full-screen' />
            </CSSTransition>
          }
        </TransitionGroup>
      </div>
    );
  }
}

AuthForm.propTypes = {
  auth: PropTypes.object.isRequired,
  showAuthForm: PropTypes.func.isRequired,
  hideAuthForm: PropTypes.func.isRequired
};

AuthForm.defaultProps = {};

function mapStateToProps (state) {
  return {
    auth: state.get('auth')
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    hideAuthForm,
    showAuthForm
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthForm);



// WEBPACK FOOTER //
// ./src/ui/AuthForm/AuthForm.jsx